module.exports = __webpack_public_path__ + "fonts/blogmarketing-image-7.png!static";